import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter,
  AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { BadgeCheck, Building, Building2, Target } from "lucide-react";
import { cn } from "@/lib/utils";

export function ConfirmDialog({ open, onOpenChange, title, description, confirmLabel = "Supprimer", onConfirm, loading }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-dialog-cancel">Annuler</AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-dialog-confirm"
            disabled={loading}
            onClick={(e) => { e.preventDefault(); onConfirm(); }}
            className={confirmLabel === "Supprimer" ? "bg-red-600 hover:bg-red-700" : ""}
          >
            {loading ? "En cours…" : confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

const pill = "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[11px] font-bold";

export function MembershipBadge({ value }) {
  if (!value) return null;
  const isMember = value.toLowerCase().startsWith("adh");
  const isFormer = value.toLowerCase().startsWith("ancien");
  if (!isMember && !isFormer) return <span className={cn(pill, "border-stone-200 bg-stone-50 text-stone-500")}>{value}</span>;
  return (
    <span data-testid="membership-badge" className={cn(pill, isMember ? "border-green-300 bg-green-50 text-green-800" : "border-stone-200 bg-stone-100 text-stone-600")}>
      {isMember && <BadgeCheck className="h-3 w-3" />} {value}
    </span>
  );
}

export function OrgStatusBadges({ org }) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {org.is_member && <span data-testid="org-badge-member" className={cn(pill, "border-green-300 bg-green-50 text-green-800")}><BadgeCheck className="h-3 w-3" /> Adhérent</span>}
      {org.is_tenant && <span data-testid="org-badge-tenant" className={cn(pill, "border-sky-300 bg-sky-50 text-sky-800")}><Building className="h-3 w-3" /> Locataire</span>}
      {org.is_domiciled && <span data-testid="org-badge-domiciled" className={cn(pill, "border-indigo-300 bg-indigo-50 text-indigo-800")}><Building2 className="h-3 w-3" /> Domicilié</span>}
      {org.is_prospect && <span data-testid="org-badge-prospect" className={cn(pill, "border-amber-300 bg-amber-50 text-amber-800")}><Target className="h-3 w-3" /> Prospect</span>}
    </div>
  );
}
